export const BACKEND_URL = "https://srv1.voskool.com";
export const API = "/api";
export const LAUNCH_DATE = '2023/10/14 23:59';
export const PAYSTACK_LIVE_KEY = "pk_live_287412778b57741a82063d71e43e3e242dbbf3e0";